import React from 'react';
import HeroSection from './sections/HeroSection';
import TrustBar from './sections/TrustBar';
import ProblemSection from './sections/ProblemSection';
import ProductShowcase from './sections/ProductShowcase';
import AIShowcaseSection from './sections/AIShowcaseSection';
import ComparisonSection from './sections/ComparisonSection';
import AIAssistantDemo from './sections/AIAssistantDemo';
import FeaturesSection from './sections/FeaturesSection';
import FrameworksSection from './sections/FrameworksSection';
import HowItWorksSection from './sections/HowItWorksSection';
import IntegrationsSection from './sections/IntegrationsSection';
import PricingSection from './sections/PricingSection';
import SecuritySection from './sections/SecuritySection';
import FAQSection from './sections/FAQSection';
import FinalCTASection from './sections/FinalCTASection';
import TestimonialBar from './sections/TestimonialBar';
import UnderTheHoodSection from './sections/UnderTheHoodSection';
import CapabilitiesSection from './sections/CapabilitiesSection';
import FrameworksMarquee from './sections/FrameworksMarquee';
import ScrollReveal from './shared/ScrollReveal';
import ScrollProgressBar from './shared/ScrollProgressBar';
import CursorSpotlight from './shared/CursorSpotlight';

/**
 * ESGCaffe Landing Page — Breww-inspired motion + ESG content/palette (light).
 *
 * Global motion additions:
 *   - ScrollProgressBar: fixed 3px gradient bar at top, tracks scrollYProgress
 *   - CursorSpotlight: soft radial glow following the cursor (desktop only)
 *   - ScrollReveal wraps every non-hero section for fade-up on entry
 *   - FrameworksMarquee: infinite dual-row scroll of framework chips
 *
 * Narrative flow:
 *   AWARENESS  → Hero + Trust + Frameworks marquee
 *   PAIN       → Problem
 *   SOLUTION   → Product + Capabilities + AI + Under-the-hood
 *   PROOF      → Comparison + AI Demo
 *   DEPTH      → Features + Frameworks + How + Integrations
 *   CONVERSION → Security + Pricing + FAQ + Final CTA
 */
const Reveal = ({ children, delay }) => (
  <ScrollReveal delay={delay} y={48} duration={0.75}>{children}</ScrollReveal>
);

const ESGLandingPageNew = () => {
  return (
    <>
      <ScrollProgressBar height={3} />
      <CursorSpotlight />
      <main>
        {/* ── AWARENESS ── */}
        <HeroSection />
        <Reveal><TestimonialBar /></Reveal>
        <Reveal><TrustBar /></Reveal>
        <FrameworksMarquee />

        {/* ── PAIN ── */}
        <Reveal><ProblemSection /></Reveal>

        {/* ── SOLUTION ── */}
        <Reveal><ProductShowcase /></Reveal>
        <CapabilitiesSection />
        <Reveal><AIShowcaseSection /></Reveal>
        <UnderTheHoodSection />

        {/* ── PROOF ── */}
        <Reveal><ComparisonSection /></Reveal>
        <Reveal><AIAssistantDemo /></Reveal>

        {/* ── DEPTH ── */}
        <Reveal><FeaturesSection /></Reveal>
        <Reveal><FrameworksSection /></Reveal>
        <Reveal><HowItWorksSection /></Reveal>
        <Reveal><IntegrationsSection /></Reveal>

        {/* ── CONVERSION ── */}
        <Reveal><SecuritySection /></Reveal>
        <Reveal><PricingSection /></Reveal>
        <Reveal><FAQSection /></Reveal>
        <Reveal><FinalCTASection /></Reveal>
      </main>
    </>
  );
};

export default ESGLandingPageNew;
